// Rellax Parallax Scrolling for Element
// Including this anywhere on a apge will activate all .rellax elements as parallax scrolling elements.
import { Controller } from '@hotwired/stimulus'
import Rellax from 'rellax'

export default class extends Controller {
  connect() {
    this.rellax = new Rellax('.rellax')
  }

  disconnect() {
    if (this.rellax) {
      this.rellax.destroy()
    }
  }
}
